import { Injectable } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { TermAndConditionService } from '../service/term-and-condition.service';

@Injectable({
    providedIn: 'root'
})
export class TermAndConditionValidators
{
    constructor(private termAndConditionService: TermAndConditionService) { }

    public validateTermAndConditionNameUnique(control: UntypedFormControl, initialName: string): any
    {
        return new Promise(resolve =>
        {
            if (control !== null && initialName !== control.value)
            {
                this.termAndConditionService.existsTermAndConditionName(control.value).subscribe({
                    next: (response) =>
                    {
                        if (response)
                        {
                            resolve({ nameExists: true });
                        }
                        else
                        {
                            resolve(null);
                        }
                    }
                });
            }
            else
            {
                resolve(null);
            }
        });
    }
}
